import { CommonModule, LocationStrategy } from "@angular/common";
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { NavigationExtras, Router, RouterModule } from "@angular/router";
import { Enum } from "../helpers/enums/enum";
import { CommunicationService } from "../services/communication.service";
import { HttpErrorResponse } from "@angular/common/http";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { SeamlessHeaderComponent } from "../shared/seamless-header.component";

@Component({
  selector: "app-reduce-debt-spl",
  standalone: true,
  imports: [CommonModule, SeamlessHeaderComponent, RouterModule],
  templateUrl: "./reduce-debt-spl.component.html",
  styleUrl: "./reduce-debt-spl.component.css",
})
export class ReduceDebtSplComponent {

  @ViewChild("callbackStatusModel", { static: false })
  callbackStatusModel: ElementRef;

  allowNavigation = false;
  username: string = "";
  userName = "";
  modalOptions: NgbModalOptions;
  moved = false;
  displayDbQuoteSection = false;
  callbackErrorMsg = "";
  callbackSuccessMsg = "";
  monthlyInstalment;
  
  setPosition = false;
  splStatus;campaignSourceType;
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private communicationService: CommunicationService,
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      keyboard: false,
    };
  }

  ngOnInit() {
    this.splStatus=sessionStorage.getItem('loadProductsQualify') ? JSON.parse(sessionStorage.getItem('loadProductsQualify')) : null;
    this.splStatus=this.splStatus?.splResponse;
    this.SPLAutoInsert();
    localStorage.setItem("PageUrls", "onboarding");
    let userDataStr = localStorage.getItem("apiUserModel");
    let userData = userDataStr ? JSON.parse(userDataStr) : null;
    this.userName = userData?.given_name;

    setTimeout(() => {
      this.moved = true;
    }, 2000);
    setTimeout(() => {
      this.displayDbQuoteSection = true;
      this.setPosition = true;
      this.renderer.addClass(this.el.nativeElement, "bg-active");
    }, 2500);
  }



  closePopup() {
    this.modalService.dismissAll();
    this.callbackErrorMsg = "";
    this.router.navigate(["/ready"]);
  }

  SkipCallback(){
    this.modalService.dismissAll();
    this.closePopup();
  }
  navigateToDashboard() {
    // set flag in session storgage
    sessionStorage.setItem("splOnBoardingVisited", "true");
    this.router.navigateByUrl("/portal/dashboard?onbId=splOnboarding");
  }
  
  cleanupStorage() {
    localStorage.removeItem("OnLoadCheck");
  }
  allowUserNavigation() {
    this.allowNavigation = true;
  }
    SPLAutoInsert(){
    this.communicationService.IDMLeadautoInsert().subscribe({
        next: (data: any) => {
      sessionStorage.setItem('isAutoInserted', 'true');
}});
 }

   splCallbackApplyNow() {
    if (this.splStatus != null) {
      if (this.splStatus.criteria == 'Maybe-Low') {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPLDeclineMedium;
      } else if (this.splStatus.criteria == 'Decline') {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPLDeclineLow;
      } else {
        this.campaignSourceType = Enum.LmsCampaignSourceType.SPL;
      }
    }
    this.callbackErrorMsg = '';
    this.callbackSuccessMsg = '';
    this.userCallback();
  }
   userCallback() {
      var payload = {
        CampaignSourceType: this.campaignSourceType
      }
      this.communicationService.userCallbackSource(payload).subscribe({
          next: (data: any) => {
        this.modalService.dismissAll();
        this.modalService.open(this.callbackStatusModel, this.modalOptions)
      }, error: (err: HttpErrorResponse) => {
        this.modalService.dismissAll();
        this.modalService.open(this.callbackStatusModel, this.modalOptions)
        this.callbackErrorMsg = 'Something went wrong. Please try again later';
        this.modalService.dismissAll();
      }});
    }
}
